import React, { useState } from "react";
import { images } from "../../constants";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

import SocialPhone from "../SocialMediaPhone/SocialPhone";
import "./Navbar.css";
const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <a href="#home">
          <img src={images.logo} alt="logo" />
        </a>
      </div>

      <ul className="app__navbar-links">
        {["home", "about", "work", "skills", "contact"].map((item, index) => (
          <li className="app__flex p_text" key={index}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className="app__navbar-menu"
        onClick={() => setToggle(!toggle)}
      >
        <HiMenuAlt4 />
      </button>

      {toggle && (
        <div className="toggle__menu">
          <HiX onClick={() => setToggle(!toggle)} />

          <ul>
            {["home", "about", "work", "skills", "contact"].map(
              (item, index) => (
                <li className="app__flex p_text" key={index}>
                  <a href={`#${item}`} onClick={() => setToggle(!toggle)}>
                    {item}
                  </a>

                  <div />
                </li>
              )
            )}

            <SocialPhone />
          </ul>
        </div>
      )}
      {/* <div className="app__navbar-menu" onClick={() => setToggle(true)}>
        <HiMenuAlt4 />
      </div> */}
    </nav>
  );
};

export default Navbar;
